import React from 'react';
import Popup from '@src/components/Popup/Popup';
import SoundsSettings from '@src/components/_layouts/Default/components/settings/notifications/SoundsSettings';
import DeadlineTimerColorsSettings
    from '@src/components/_layouts/Default/components/settings/deadline-timer-colors/DeadlineTimerColorsSettings';

export default function SettingsPopup(props: { closePopup: () => void }) {
    return <Popup
            title="SoundsSettings.popup-title"
            closePopup={props.closePopup}
    >
        <SoundsSettings/>
        <DeadlineTimerColorsSettings/>
    </Popup>;
}
